import { NAME } from './constants';
import { router } from './router';

export const CorporateProfile = {
	name: NAME,
	router,
};
